export const getCtaIndex = (element) => {
	const ctaElement =
		element instanceof Element
			? element.closest('[class*="cst-btn"]') ||
			  element.closest('[data-name*="content-cta-col"]')
			: null;

	let ctaClass = null;

	if (ctaElement) {
		ctaClass =
			[...(ctaElement?.classList || [])]?.find((item) =>
				item.includes('cst-btn')
			) || ctaElement.getAttribute('data-name');
	}

	return !ctaClass ? null : Number(ctaClass.split('-').pop());
};
